<template>
    <v-card>
        <!-- <v-card-title> -->
            <v-toolbar flat :color="orgLevel?'blue lighten-4':'white'">
            <h3 class="headline mb-0">{{section.label}}</h3>
                        <v-spacer></v-spacer>
            <v-btn icon @click.native="show = !show">
                <v-icon>{{ show ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
            </v-btn>
            </v-toolbar>
        <!-- </v-card-title> -->
        <v-card-text v-show="show">
        <span class="grey--text text--darken-2">{{section.description}}</span>
            <v-form :ref="'form-' + section.id" v-model="valid" @submit.prevent>
                <v-layout wrap v-if="showSystemInfo">
                    <v-flex xs12 sm5 pa-2 ma-2>
                        <v-text-field
                        label="Name"
                        v-model="system.name"
                        @input="change"
                        :rules="[rules.required]"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm5 pa-2 ma-2>
                        <v-textarea
                        label="Description"
                        rows="2"
                        v-model="system.description"
                        @input="change"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
              <v-layout wrap>
                  <data-entry-field
                    v-for="(property,j) in section.properties" :key="j+rerender-rerender"
                    :property="property" :locked="property.lockedEx" :visible="true" v-show="property.visibleEx"
                    @change="change" @linkedwindowclosed="linkedwindowclosed" @linkedwindowopening="linkedwindowopening">
                  </data-entry-field>
              </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions v-show="show">
            <v-btn text color="orange" :disabled="!changed" @click="reset(section.id)">Reset</v-btn>
            <v-btn text v-if="section.needsValidation && (system.hasDriver || system.isCloudSystem)" color="orange" :disabled="!valid" @click="validate(section.id)">Validate</v-btn>
            <v-btn text color="orange" :disabled="!changed || !valid" @click="apply(section.id)">Save</v-btn>
            <v-spacer></v-spacer>
            <v-alert v-if="validationMessage.length > 0" :value="validationMessage" type="error" outlined>{{validationMessage}}</v-alert>
        </v-card-actions>
        <v-dialog v-model="systemRemoteValidationDialog" persistent width="500">
            <v-card>
                <v-card-title class="headline">{{systemRemoteValidationStatus}}</v-card-title>
                <v-card-text>
                    <h3>{{systemRemoteValidationMessage}}</h3>
                    <p v-if="systemRemoteValidationMessages.length">Details:
                                <v-btn icon @click.native="showErrDetails = !showErrDetails">
                                    <v-icon>{{ showErrDetails ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
                                </v-btn>
                    </p>
                    <div v-if="showErrDetails">
                        <p v-for="(msg, i) in systemRemoteValidationMessages" :key="i">
                            {{msg}}
                        </p>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="orange" @click="systemRemoteValidationDialog=false" >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
           <v-dialog
                v-model="waitDialog"
                persistent
                width="300"
                >
                <v-card
                    color="primary"
                    dark
                >
                    <v-card-text>
                    Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
      </v-card>
</template>
<script>
import DataEntryField from './DataEntryField.vue'
import _ from 'lodash'
import { nanoid } from 'nanoid'
export default {
    components: {
        'data-entry-field': DataEntryField
    },
    props: {
        system: Object,
        sections: Array,
        section: Object,
        display: Boolean,
        displaySystemInfo: Boolean,
        userIsSU: Boolean,
        userIsSUPro: Boolean,
        orgLevel: Boolean,
        sectionIdChanged: String
    },
    data() {
        return {
            showSystemInfo: this.displaySystemInfo,
            show: this.display,
            waitDialog: false,
            valid: true,
            validationMessage: '',
            rerender: 0,
            changed: false,
            systemRemoteValidationStatus: '',
            systemRemoteValidationMessage: '',
            systemRemoteValidationMessages: [],
            systemRemoteValidationDialog: false,
            showErrDetails: false,
            rules: {
                required: value => !!value || 'Required.'
            },
            lastSectionIdChanged: null
        }
    },
    methods: {
        getVisible(props) {
            return _.filter(props, {visible: true})
        },
        async reset(sectionId) {
            if (this.orgLevel) {
                await this.$store.dispatch("systems/resetActiveSystemOrgLevelConfigs", sectionId)
            } else {
                await this.$store.dispatch("systems/resetActiveSystemDataEntrySection", {sectionId, systemInfo: this.showSystemInfo})
            }
            this.calculateValues(true)
            this.updateVisibilityAndLock()
            this.changed = false
        },
        async apply(sectionId) {
            try {
                if (this.testRequiredInValidation()) {
                    let result
                    if (this.orgLevel) {
                        result = await this.$store.dispatch("systems/saveActiveSystemOrgLevelConfigs", sectionId)
                    } else {
                        result = await this.$store.dispatch("systems/saveActiveSystemDataEntrySection", {sectionId, systemInfo: this.showSystemInfo})
                    }
                    if (result) {
                        this.changed = false
                    }
                }
            } catch (e) {
                console.error(e)
            }
        },
        async validate(sectionId) {
            try {
                if (this.testRequiredInValidation()) {

                    if (this.changed) {
                        alert('Note: Validation will use the saved system configuration only. Your unsaved changes will not be included.')
                    }

                    this.systemRemoteValidationStatus = ''
                    this.systemRemoteValidationMessage = ''
                    this.systemRemoteValidationMessages = []

                    this.waitDialog = true
                    const result = await this.$store.dispatch("systems/validateActiveSystemDataEntrySection", sectionId)
                    this.waitDialog = false

                    if (result && result.success) {
                        this.systemRemoteValidationStatus = "Validation was successful"
                    } else {
                        this.systemRemoteValidationStatus = "Validation failed"
                        this.systemRemoteValidationMessage = result.message
                    }
                    this.systemRemoteValidationMessages = result.messages || []

                    this.systemRemoteValidationDialog = true
                }
            } catch (e) {
                this.waitDialog = false
                console.error(e)
            }
        },
        change(prop) {
            // console.log('change ' + prop.fieldName + ' => ' + prop.value + ' ' + this.valid)
            this.runChanges(prop)
            this.changed = true
            this.validationMessage=''
            this.calculateValues(false, prop)
            this.updateVisibilityAndLock()
            this.$refs[`form-${this.section.id}`].validate()
            this.$emit('sectionPropChanged', {sectionId: this.section.id, prop})
        },
        runChanges(changedItem) {
            if (changedItem.onchange && changedItem.onchange.includes("section.")) {
                let section = {}
                let sectionProp = {}
                _.forEach(this.sections, (_section) => {
                    if (_section) {
                        _.forEach(_section.properties, (prop) => {
                            section[prop.fieldName] = prop.value
                            sectionProp[prop.fieldName] = _section
                        })
                    }
                })
                eval(changedItem.onchange)
                let keys = _.keys(section)
                _.forEach(keys, (key) => {
                    let secPtr = sectionProp[key]
                    if (secPtr) {
                        secPtr.properties[key] = section[key]
                    }
                })
            }
        },
        calculateValue(expr, item) {
            // if (!item.defaultValue || !item.defaultValue.includes("eval:")) {
            //     return null
            // }
            if (!this.sections) {
                return null
            }

            try {

                if (expr === 'guid'){
                    if (item.value) {
                        return null
                    }
                    const res = nanoid()
                    return res
                }

                let section = {}
                _.forEach(this.sections, (_section) => {
                    if (_section) {
                        _.forEach(_section.properties, (prop) => {
                            section[prop.fieldName] = prop.value
                        })
                    }
                })

                const result = eval(expr)
                return result
            } catch (e) {
                console.error(e)
                return null
            }
        },
        calculateValues(initial, changedItem) {
            let childChanges = []

            _.forEach(this.section.properties, (prop) => {
                if (!prop.defaultValue || !prop.defaultValue.includes || !prop.defaultValue.includes("eval:")) {
                    return
                }

                let calc = false
                const expr = prop.defaultValue.substring(5)
                if (initial) {
                    calc = _.isNull(prop.value) || (prop.value === '')
                } else if (changedItem) {
                    calc = (prop.fieldName !== changedItem.fieldName) && (expr.includes(changedItem.fieldName))
                }
                if (calc) {
                    const val = this.calculateValue(expr, prop)
                    if (val !== null) {
                        const oldval = prop.value
                        prop.value = val
                        this.changed = this.changed || (val !== oldval)
                        if (!initial && (val !== oldval)) {
                            childChanges.push(prop)
                        }
                    }
                }
            })

            _.forEach(childChanges, (changedProp) => {
                this.calculateValues(false, changedProp)
            })
        },
        updateVisibilityAndLock() {
            _.forEach(this.section.properties, (prop) => {
                this.setPropertyLocked(prop)
                this.setPropertyVisible(prop)
                this.setPropertyReadonly(prop)
            })
        },
        linkedwindowclosed() {
            this.$emit('systemdirty')
        },
        linkedwindowopening(url) {
            var objActivity = {
                action: 'navigate',
                appId: 'cpm-admin',
                view: '',
                tab: '',
                url: window.location.href,
                source: this.system.id,
                data: 'orgId: - window.open - url :' + url
            };
            this.$store.dispatch('status/logActivity',objActivity);
        },
        testRequiredInValidation() {

            if (!this.sections) {
                return
            }
            let section = {}
            _.forEach(this.sections, (_section) => {
                _.forEach(_section.properties, (prop) => {
                    section[prop.fieldName] = prop.value
                })
            })

            this.validationMessage = ''
            let validationResult = true
            _.forEach(this.section.properties, (property) => {
                if (!property.validation || !property.validation.includes('value:')) {
                    return
                }
                let validation = property.validation
                let p = validation.indexOf('value:')
                let q = validation.indexOf(',', p)
                if (q < 0) {
                    q = validation.length
                }
                let expr = validation.substring(p+6, q)

                let tokens = expr.split('=>')

                //if expression contains a conditional part e.g. abc=>def, and eval(abc) is false, return true, else return eval of def
                //if expression doesn't contain a conditional, but only an expression e.g. def, return eval of def
                const eval0result = eval(tokens[0])
                const evalresult = ((tokens.length > 1) && eval0result) ? eval(tokens[1]) : ((tokens.length > 1) ? true : eval0result)
                validationResult = validationResult && evalresult

                if (!evalresult) {
                    if (property.validation.includes('message:')) {
                        p = validation.indexOf('message:')
                        q = validation.indexOf(',', p)
                        if (q < 0) {
                            q = validation.length
                        }
                        let message = validation.substring(p+8, q)
                        this.validationMessage = this.validationMessage + (this.validationMessage ? '; ' : '') + message
                    }
                }
            })

            return validationResult
        },
        setPropertyLocked(item) {
            if (item.locked && item.locked.includes && item.locked.includes("eval:")) {
                const expr = item.locked.substring(5)
                const val = this.calculateValue(expr, item)
                item.lockedEx = val === null ? false : val
                this.rerender++;
            } else {
                item.lockedEx = item.locked
            }
        },
        setPropertyReadonly(item) {
            if (item.readonly && item.readonly.includes && item.readonly.includes("eval:")) {
                const expr = item.readonly.substring(5)
                const val = this.calculateValue(expr, item)
                item.readonlyEx = val === null ? false : val
                this.rerender++;
            } else {
                item.readonlyEx = item.readonly
            }
        },
        setPropertyVisible(item) {
            if (item.visible && item.visible.includes && item.visible.includes("eval:")) {
                const expr = item.visible.substring(5);
                const val = this.calculateValue(expr, item);
                item.visibleEx = val === null ? true : val;
                this.rerender++;
            } else {
                item.visibleEx = item.visible;
            }

            if (item.roles && (item.roles !== 'all')) {
                let allowed = true
                let rolesList = item.roles.split(',')
                if (rolesList.includes('suPro')) {
                     allowed = this.userIsSUPro
                }
                if (rolesList.includes('su')) {
                    allowed = allowed || this.userIsSU
                }

                item.visibleEx = item.visibleEx && allowed
                // console.log("Allowed " + allowed + " roles list " + rolesList + " isSU " + this.userIsSUPro )
            }
        }
    },
    created() {
        this.calculateValues(true)
        this.updateVisibilityAndLock()
    },
    watch: {
        sectionIdChanged: function(val) {
            if (val === this.section.id) {
                return
            }
            if (val && (val !== this.lastSectionIdChanged)) {
                this.lastSectionIdChanged = val
                this.calculateValues(false)
                this.updateVisibilityAndLock()
            } else if (!val) {
                this.lastSectionIdChanged = null
            }
        }
    }
}
</script>
